// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3Yl3i","productName":"Table_productName__3JK6e"};